export class CookiesAgreement {
	rootSelector = '.js-cookies-agreement';
	buttonSelector = '.cookies-agreement__button';

	constructor() {
		this.init();
	}

	init() {
		this.root = document.querySelector(this.rootSelector);
		if (!this.root) return;

		this.button = this.root.querySelector(this.buttonSelector);
		if (!this.button) return;

		this.bindEvents();
	}

	handleClick = () => {
		this.root.dispatchEvent(
			new CustomEvent('cookiesAgreement', {
				detail: { accepted: true },
			}),
		);
	};

	bindEvents() {
		this.button.addEventListener('click', this.handleClick);
	}
}
